export class ServiceRegister{
  id:number;
  name:string="";
  taxName:string="";
  email:string="";
  phone:string="";
  quantity:number;
  price:number;
  serviceName:string="";
  serviceId:number;
  calendarId:number;
  isNew:boolean;
  subject:string="";
  message:string="";
  isActive: boolean;
  isCanceled: boolean;
  dateCreated:any;
  note:string="";
  packageName:string="";
  paymentId:string="";

  cityId:number=0;
  townId:number=0;
  address:string="";
  taxOffice:string="";
  taxNumberOrTC:string="";
  isCompany: boolean;
  checkRegistration():boolean{
    if(
      this.name==null ||  this.name=="" ||
      this.email==null ||  this.email=="" ||
      this.taxName==null ||  this.taxName=="" ||
      this.taxNumberOrTC==null||   this.taxNumberOrTC=="" ||
      this.phone==null ||  this.phone==""  ||
      this.cityId==null ||  this.cityId==0 ||
      this.townId==null ||  this.townId==0 ||
      this.address==null ||  this.address=="" ||
      (this.isCompany && this.taxOffice=="") )
      return false;
    return true;
  }
}
